import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { ControlListenerPlugin } from '@controls/model/control-listener-plugin';
import { Observable } from 'rxjs';

export abstract class StandardListenerPlugin<C> implements ControlListenerPlugin<C> {
  abstract get symbol(): symbol;
  abstract connect(
    config: C,
    ctrl: AbstractControl,
    form: UntypedFormGroup,
    valueChanges$?: Observable<any>
  ): Observable<any>;

  public isConnected(ctrl: AbstractControl): boolean {
    return ctrl[this.symbol];
  }

  protected markAsConnected(ctrl: AbstractControl): void {
    ctrl[this.symbol] = true;
  }

  disconnect(ctrl: AbstractControl): void {
    delete ctrl[this.symbol];
  }
}
